import { render, staticRenderFns } from "./ItemCollection.vue?vue&type=template&id=596ddf8a&scoped=true&"
import script from "./ItemCollection.vue?vue&type=script&lang=js&"
export * from "./ItemCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ddf8a",
  null
  
)

export default component.exports